import { Radio, RadioGroup } from '@availity/form';
import { FormGroup } from 'reactstrap';

const InputForm = ({
  name,
  labels,
  values,
  readOnly,
  radioStyle,
  children,
}) => {
  const disabledStyle = readOnly ? { cursor: 'not-allowed' } : {};
  return (
    <FormGroup>
      <RadioGroup name={name} label={children} inline>
        <div className="d-flex align-items-center">
          {labels.map((label, index) => (
            <Radio
              key={index}
              name={name}
              label={label}
              value={values[index]}
              disabled={readOnly}
              style={{ ...radioStyle, ...disabledStyle }}
            />
          ))}
        </div>
      </RadioGroup>
    </FormGroup>
  );
};

export default InputForm;
